import { render } from "./fzhsSubjectBalance.vue?vue&type=template&id=6ae65f73&scoped=true"
import script from "./fzhsSubjectBalance.vue?vue&type=script&lang=js"
export * from "./fzhsSubjectBalance.vue?vue&type=script&lang=js"

import "./fzhsSubjectBalance.vue?vue&type=style&index=0&id=6ae65f73&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae65f73"]])

export default __exports__